import { connect } from 'react-redux'
import * as notifications from '../../modules/notification/actions'
import { addIcon, removeIcon } from '../../Actions/iconAction'
import { openIconDetail, closeIconDetail } from '../../Actions/iconDetailAction'
import IconDetail from './IconDetail'

export default connect(
	store => {
		const icon = store.iconDetail.icon
		const collection = store.iconstore.iconstore
		return {
			icon,
			icons: store.localstore.icons,
			inCollection: !!icon && (collection.selected_glyphs || []).includes(icon.id)
		}
	},
	dispatch => ({
		dispatch,
		showError: err => notifications.showError(err)(dispatch),
		onOpen: icon => dispatch(openIconDetail(icon)),
		onClose: () => dispatch(closeIconDetail()),
		// The button's own state change is the feedback; no toast
		onToggleCollection: (icon, inCollection) => dispatch(inCollection ? removeIcon(icon, 'icofont') : addIcon(icon, 'icofont'))
	})
)(IconDetail)
